<template>
  <v-container class="cmp-licencing-licence-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <div class="dt-details2">
        <div class="dt-details--header">
          <div
            class="title"
            :title="
              selectedLicenceDetails &&
              selectedLicenceDetails.licence &&
              selectedLicenceDetails.licence.licence_account_name
            "
          >
            <span
              v-if="selectedLicenceDetails && selectedLicenceDetails.licence"
              >{{
                selectedLicenceDetails.licence.licence_name || "Licence Name"
              }}</span
            >
          </div>
        </div>
        <div class="dt-details--body">
          <div class="dt-details--col">
            <div class="ut-flex">
              <div
                v-if="
                  selectedLicenceDetails &&
                  selectedLicenceDetails.licence_account
                "
              >
                {{
                  selectedLicenceDetails.licence.licence_name || "Licence Name"
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <glayout
        :tabs="licenceSidewindowTab"
        :options="[
          {
            text: 'Labelcopy',
            value: 'labelcopy',
          },
        ]"
        :loading="selectedLicenceDetails && selectedLicenceDetails.loading"
        @optionClicked="onTabOptionClicked"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox :title="$t('licence_setup')" h="260">
                <LicenceSetup
                  :selectedLicenceDetails="selectedLicenceDetails"
                  @changed="onUpdated"
                />
              </gbox>
              <gbox v-if="selectedLicenceDetails" :title="$t('royalty_info')">
                <DBoxTextarea
                  :yellowStyle="false"
                  :id="'notes'"
                  :value="
                    replaceAsciiLineBreak(
                      selectedLicenceDetails.licence.royalty_info
                    )
                  "
                  @blur="
                    (e) =>
                      onUpdated({
                        name: 'royalty_info',
                        value: e.target.value,
                      })
                  "
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedLicenceDetails &&
                      selectedLicenceDetails.files &&
                      selectedLicenceDetails.files.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('related_documents')"
              >
                <DBoxFiles
                  :files="selectedLicenceDetails.files"
                  :externalId="`${this.licence_id}`"
                  :externalTable="'licence'"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('adv_setup')" h="227">
                <AdvanceLicenceSetup
                  :selectedLicenceDetails="selectedLicenceDetails"
                  @changed="onUpdated"
                />
              </gbox>
              <gbox
                v-if="selectedLicenceDetails"
                :title="$t('notes')"
                bc="var(--bc-note)"
              >
                <DBoxTextarea
                  :id="'notes'"
                  :value="
                    replaceAsciiLineBreak(
                      selectedLicenceDetails.licence.internal_notes
                    )
                  "
                  @blur="
                    (e) =>
                      onUpdated({
                        name: 'internal_notes',
                        value: e.target.value,
                      })
                  "
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="tab_title_tasks">
          <gbox 
            :title="`${$t('tab_title_tasks')}`"
              :h="boxHeightNamed({
                    rowCount:
                      selectedLicenceDetails &&
                      selectedLicenceDetails.tasks &&
                      selectedLicenceDetails.tasks.length,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    rowHeight: 32,
                    min: 1,
                    max:10
                  })
                "
          >
            <DTTaskList :storeConfig="dBoxTaskConfig" :selectedDetails="selectedLicenceDetails" :externalTable="'licence'"/>
          </gbox>
        </gtab>
        <gtab id="assets">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedLicenceDetails &&
                      selectedLicenceDetails.tracks &&
                      selectedLicenceDetails.tracks.length,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    rowHeight: 32,
                    min: 1,
                    max:10
                  })
                "
                :title="`${$t('related')} ${$t('assets')}`"
              >
                <RelatedAssets
                  :selectedLicenceDetails="selectedLicenceDetails"
                  @delete="deleteTrack"
                  @create="onAddTrack"
                  @refresh="onRefresh"
                />
              </gbox>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedLicenceDetails &&
                      selectedLicenceDetails.royalty_accounts &&
                      selectedLicenceDetails.royalty_accounts.length,
                    offset: NTOffsets.WithHeader,
                    rowHeight: 32,
                    min: 1,
                    max:10
                  })
                "
                :title="$t('royalty_account')"
              >
                <RelatedRoyaltyAccount
                  :selectedLicenceDetails="selectedLicenceDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="income">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedLicenceDetails &&
                      selectedLicenceDetails.licence_incomes &&
                      selectedLicenceDetails.licence_incomes.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('income')"
              >
                <LicenceIncomeList
                  @menu_click="onLicenceIncomeCreateInvoice"
                  @addIcome="addIcome"
                  @delete="onIncomeDeleted"
                  :selectedLicenceDetails="selectedLicenceDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>

    <ModalContainer :modalKey="'licenceIncomeForm'" :width="'small'">
      <LicenceIncomeForm
        :selectedLicenceDetails="selectedLicenceDetails"
        @cancelled="onDialogCancelled"
        @added="onIncomeAdded"
        @edited="onIncomeEdited"
      />
    </ModalContainer>

    <ModalContainer
      :modalKey="'labelCopy'"
      :height="'500px'"
      :width="'medium2'"
    >
      <LabelCopy @cancelled="onDialogCancelled" />
    </ModalContainer>

    <ModalContainer
      @cancelled="onModalCancelled"
      :modalKey="'createInvoiceFromLicencesIncome'"
      :width="'400'"
    >
      <SelectInvoiceProject
        :invoiceProjects="
          (createInvoiceData && createInvoiceData.invoice_projects) || []
        "
        :loading="invoiceProjectLoading"
        :loadingText="invoiceProjectLoadingText"
        @selected="onInvoiceProjectSelected"
        @cancelled="onModalCancelled"
      />
    </ModalContainer>
    <ModalContainer
      :modalKey="'selectAssetModal'"
      :width="'250'"
    >
      <SelectAssetModal @cancelled="onDialogCancelled" />
    </ModalContainer>
    <ModalContainer
      :modalKey="'addNewAssetModal'"
      :width="'1000'"
    >
      <AddNewAssetModal  @create="onAddAsset" @cancelled="onDialogCancelled" />
    </ModalContainer>
    <ModalContainer
      :modalKey="'addNewAssetModalIncome'"
      :width="'1000'"
    >
      <AssetModalNewIncome v-if="AssetArray.length>1" :list="AssetArray" @create="onAddAsset" @cancelled="onDialogCancelled" />
    </ModalContainer>
  </v-container>
</template>

<script>
import { LicenceStoreNamespace, LicenceStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapGetterObject, mapActionObject } from "../../../../store/global";

import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import { licencesListLDTRoutes } from "../../router/routes";
import { checkTabListPermission } from "../../../../router/guard";

import RealtedContacts from "@/dt-plugins/add-contact-relation/related-contacts";
import DBoxTextarea from "../../../../dt-plugins/dbox-textarea/dbox-textarea";
//import AccountSetup from './account-setup';

import { licenceActions } from "../../store/licence/actions";
import { licenceGetters } from "../../store/licence/getters";
import {
  createModalMixin,
  closeModalRoute,
  openModalRoute2,
} from "../../../../dt-plugins/modal/modal.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";
import LicenceSetup from "./licence-setup";
import AdvanceLicenceSetup from "./licence-advance-setup";
import DBoxFiles from "@/dt-plugins/dbox-files/dbox-files";
import RelatedAssets from "./related-asset-list";
import RelatedRoyaltyAccount from "./related-royalty-accounts-list";
import LicenceIncomeList from "./licence-income-list";
import LicenceIncomeForm from "./licence-income-form.vue";
import LabelCopy from "./label-copy-modal.vue";
import SelectAssetModal from "./select-asset-modal.vue";
import AddNewAssetModal from "./add-new-asset-modal.vue";

import SelectInvoiceProject from "../../../../dt-plugins/select-invoice-project/select-invoice-project-modal";
import { licenceService } from "../../services/licence.service";
import { format } from "date-fns";
import { wait } from "../../../../utility";
import { invoiceListLDTRoutes } from "../../../accounting/router/routes";
import { routeWithFrom } from '../../../../utility/route';

import DTTaskList from '@/dt-plugins/dt-task/dt-related-task.vue'
import AssetModalNewIncome from './asset-modal-new-income.vue'
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import { createDboxConfig } from "../../../../dt-plugins/dt-task/dbox-task.model";
export const moduleRoute = "licencing";
export const submenuRoute = "licence_accounts";

export default {
  components: {
    ModalContainer,
    LicenceSetup,
    AdvanceLicenceSetup,
    RealtedContacts,
    DBoxTextarea,
    DBoxFiles,
    RelatedAssets,
    RelatedRoyaltyAccount,
    LicenceIncomeList,
    LabelCopy,
    LicenceIncomeForm,
    SelectInvoiceProject,
    SelectAssetModal,
    AddNewAssetModal,
    AssetModalNewIncome,
    DTTaskList
  },
  mounted:async function () {
    const licence_statuses =this?.licencesList?.licence_statuses||[]

    if(licence_statuses.length==0)
    {
      const advancedSearchData = await licenceService.licenceAdvancedSearchModalData();
      this[ActionTypes.LicencesList.SET.ALL](advancedSearchData.data);

    }

  },
  mixins: [
    createDTGridHost(),
    createModalMixin("licenceIncomeForm"),
    createModalMixin("batchLicence"),
    createModalMixin("labelCopy"),
    createModalMixin("selectAssetModal"),
    createModalMixin("addNewAssetModal"),
    createModalMixin("addNewAssetModalIncome"),
    createModalMixin("createInvoiceFromLicencesIncome"),
  ],
  data() {
    return {
      createInvoiceData: null,
      invoiceProjectLoading: true,
      invoiceProjectLoadingText: "Loading ...",
      AssetArray:[],
      
    };
  },
  computed: {
    ...mapGetterObject(storeNS, licenceGetters),
    dBoxTaskConfig:function(){
      return createDboxConfig({
        storeNamesPace: LicenceStoreNamespace,
        detailsAction: ActionTypes.LicenceDetails,
        detailsGetterKey: "licencesDetails",
        dataKey: "tasks",
        primaryKeyValue: this.licence_id,
        externalTable: "licence",
      })
    },

    licenceSidewindowTab: function () {
      return checkTabListPermission(moduleRoute, submenuRoute, [
        {
          route: "overview",
          value: this.$t("tab_title_invoice_info"),
        },
        {
          route: "tab_title_tasks",
          value: this.$t("tab_title_tasks"),
        },
        {
          route: "assets",
          value: this.$t("assets"),
        },
        {
          route: "income",
          value: this.$t("tab_title_income"),
        },
      ]);
    },

    licence_id: function () {
      return this.$route.params.licence_id;
    },

    selectedLicenceDetails: function () {
      const licencesDetails =
        (this.licencesDetails || {})[this.licence_id] || {};
      const licence = licencesDetails.licence || {};
      const license_types = licencesDetails.license_types || [];

      const licence_statuses =this?.licencesList?.licence_statuses||[]

      // console.log("this.licencesDetails:::",licencesDetails)
      // const licence_account = licencesDetails.licence_account || {};
      // const invoice_contact = licencesDetails.invoice_contact || {};

      return {
        ...licencesDetails,
        licence,
        license_types,
        licence_statuses
        //  licence_account,
        //  invoice_contact
      };
    },
  },
  methods: {
    ...mapActionObject(storeNS, licenceActions),

    replaceAsciiLineBreak: function (asciiString) {
      const stringToReturn =  asciiString && asciiString?.replaceAll? asciiString?.replaceAll("&#10;", "\n"): "";

      return  stringToReturn && stringToReturn?.replaceAll ? stringToReturn?.replaceAll("+;", " "): "";
    },

    onTabOptionClicked(value) {
      // console.log("OOOOOOOOOO");
      // openModalRoute2(LabelCopy,'label_copy',{licence_id: this.licence_id});

      this.$router.push({
        ...this.$route,
        query: {
          modal: "label_copy",
          licence_id: this.licence_id,
        },
      });
    },

    onUpdated: function (payload) {
      this[ActionTypes.LicenceDetails.UPDATE.SINGLE]({
        ...payload,
        item: this.selectedLicenceDetails,
      });
    },

    onRelatedContactDelete: function (contact) {
      this[ActionTypes.LicenceAccountRelatedContacts.DELETE.SINGLE]({
        contact,
        licence_account: this.selectedLicenceDetails.licence_account,
      });
    },
    onRelatedContactChange: function ({ name, value, item }) {
      this[ActionTypes.LicenceAccountRelatedContacts.UPDATE.SINGLE]({
        name,
        value,
        item,
        licence_account: this.selectedLicenceDetails.licence_account,
      });
    },

    onRelatedContactSelected: function () {},

    async reloadLicenceDetails() {
      await this[ActionTypes.LicenceDetails.FETCH.SINGLE]({
        flag: true,
        licence: this.selectedLicenceDetails.licence,
        reload: true,
      });
    },

    deleteTrack: async function (payload) {
      await this[ActionTypes.LicenceRelatedTracks.DELETE.SINGLE](payload);
      await this.reloadLicenceDetails();
    },
    onAddTrack: function (payload) {
      this[ActionTypes.LicenceRelatedTracks.INSERT.SINGLE](payload);
      console.log("LLLLLLLLLLLLLLLLLLLL",payload)
      //this[ActionTypes.LicenceRelatedAssets.INSERT.SINGLE](payload);
    },
    onAddAsset:function(payload){
      this.onDialogCancelled();
      this[ActionTypes.LicenceRelatedAssets.INSERT.SINGLE](payload);
    },
    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onIncomeAdded: function (payload) {
      console.log(payload);
      const { licence_account_id } = this.selectedLicenceDetails.licence;
      this[ActionTypes.LicenceIncome.INSERT.SINGLE]({
        licence_id: this.licence_id,
        licence_account_id: licence_account_id,
      });
      this.onDialogCancelled();
    },
    onIncomeEdited: function () {
      this[ActionTypes.LicenceIncome.UPDATE.SINGLE]({
        licence_id: this.licence_id,
      });
      this.onDialogCancelled();
    },
    onIncomeDeleted: function (payload) {
      const { licence_account_id } = this.selectedLicenceDetails.licence;
      this[ActionTypes.LicenceIncome.DELETE.SINGLE]({
        ...payload,
        licence_account_id: licence_account_id,
        licence_id:this.licence_id
      });
      this.onDialogCancelled();
    },
    onLicenceIncomeCreateInvoice:async function() {

      

      // NotificationService.showNotification({
      //     text: "Creating Invoice",
      //     timeout: 5000,
      //   });
      this.$router.push({
        ...this.$route,
        query: {
          modal: "create_invoice_from_licences_income",
          external_id: this.selectedLicenceDetails.licence.licence_id,
        },
      });
      this.invoiceProjectLoading = true;
      this.invoiceProjectLoadingText = "Fetching Invoice Projects ...";

      const resData = await licenceService.invoiceProjectsForm(
        this.selectedLicenceDetails.licence.licence_id
      );

      this.invoiceProjectLoading = false;
      this.invoiceProjectLoadingText = "Loading ...";

      this.createInvoiceData = resData.data;
    },
    async onInvoiceProjectSelected(invoiceProject) {
      this.invoiceProjectLoading = true;
      this.invoiceProjectLoadingText = "Creating Invoice ...";

      // const createdInvoice = await licenceService.licenceLinesToInvoice({
      //   invoice_language: this.createInvoiceData?.user?.language || "",
      //   vat_rate1: invoiceProject.vat_rate1,
      //   vat_rate2: invoiceProject.vat_rate2,
      //   vat_rate3: 0.0,
      //   invoice_user_id: this.createInvoiceData?.user?.user_id || "",
      //   invoice_date: format(new Date(), "YYYY-MM-DD"),
      //   invoice_project_id: invoiceProject.invoice_project_id,
      //   money_account_id: invoiceProject.money_account_id,
      //   payment_method_id: invoiceProject.payment_method_id,
      //   invoice_ref_key: invoiceProject.invoice_ref,
      //   licence_id: this.createInvoiceData.licence_id,
      //   due_days: invoiceProject.due_days,
      //   discount_days: invoiceProject.discount_days,
      //   discount_percent: invoiceProject.discount_percent,
      // });

      const createdInvoice = await licenceService.createInvoiceFromLicenceAccount(this.licence_id,invoiceProject.invoice_project_id);

      await wait(200);

      this.invoiceProjectLoading = false;
      this.invoiceProjectLoadingText = "Loading ...";

      this.onModalCancelled();

      if (createdInvoice.data.invoice_id) {
        this.reloadLicenceDetails();
        routeWithFrom(this, {
          name: invoiceListLDTRoutes.names.tab,
          params: {
            invoice_id: createdInvoice.data.invoice_id,
            tab: "overview"
          }
        });
      }
    },
    onModalCancelled() {
      closeModalRoute(this, {
        external_id: undefined,
      });
    },
    onRefresh:function(){
      this[ActionTypes.LicenceDetails.FETCH.SINGLE]({licence:{licence_id:this.licence_id}, reload:true})
    },
    addIcome:async function(){
      const resData= await licenceService.addLicenceLineModal1Data(this.licence_id);
      console.log("PPPPPPPPPPPP",resData,"::::::::::")

      if(resData.data.asset_count<1){
        NotificationService.showNotification({
          text: this.$t("no_licence_assets"),
          timeout: 5000,}
        );
      }else if(resData.data.asset_count>1){
        this.AssetArray = resData.data.assets
        this.$router.push({
          ...this.$route,
          query: {
            modal: "add_new_asset_modal_income",
            licence_id: this.licence_id,
          },
        });
      }else if(resData.data.asset_count==1){
        this.$router.push({
        ...this.$route,
        query: {
          modal: "licence_income_form",
          licence_id: this.licence_id,
          licence_track_id:resData.data.licence_track_id,
          mode: "add",
        },
      });
      }
    }

    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-licencing-licence-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 129px);
  }
}
</style>
